/* MD Masala theme by Zoon Network · zoon.network */
(function () {
  'use strict';
  if (window.MDSHOP) return;
  var doc = document;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var design = !!(window.Shopify && window.Shopify.designMode);

  var clearEmpty = function (form) {
    $$('input[type="number"], input[type="text"]', form).forEach(function (i) { if (i.value.trim() === '') i.disabled = true; });
  };
  var drops = function (form) { return $$('details[data-mdshop-drop]', form); };
  var closeAll = function (form, except) { drops(form).forEach(function (d) { if (d !== except) d.open = false; }); };

  function filters(ROOT) {
    $$('[data-mdshop-filters]', ROOT).forEach(function (form) {
      if (form.mdshopOn) return;
      form.mdshopOn = true;
      form.classList.add('is-js');
      drops(form).forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) closeAll(form, d); });
      });
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.type === 'checkbox' || t.type === 'radio') {
          clearEmpty(form);
          form.classList.add('is-busy');
          form.submit();
        }
      });
      form.addEventListener('submit', function () { clearEmpty(form); });
    });
  }

  function switches(ROOT) {
    if (location.protocol === 'file:' || !window.fetch) return;
    var root = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
    var post = function (path, body) {
      return fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    };
    $$('form[data-mdsc-switch]', ROOT).forEach(function (f) {
      if (f.mdshopOn) return;
      f.mdshopOn = true;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        if (f.classList.contains('is-busy')) return;
        f.classList.add('is-busy');
        post('cart/add.js', { items: [{ id: +f.getAttribute('data-id'), quantity: +f.getAttribute('data-qty') || 1 }] })
          .then(function () { return post('cart/change.js', { id: f.getAttribute('data-key'), quantity: 0 }); })
          .then(function () { location.reload(); }, function () { f.classList.remove('is-busy'); HTMLFormElement.prototype.submit.call(f); });
      });
    });
  }

  function boot(ROOT) {
    filters(ROOT);
    switches(ROOT);
  }

  doc.addEventListener('click', function (e) {
    $$('[data-mdshop-filters]').forEach(function (form) { if (!form.contains(e.target)) closeAll(form, null); });
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-mdshop-filters]').forEach(function (form) {
      var open = drops(form).filter(function (d) { return d.open; })[0];
      if (open) { open.open = false; var s = open.querySelector('summary'); if (s) s.focus(); }
    });
  });
  window.addEventListener('pageshow', function () {
    $$('[data-mdshop-filters]').forEach(function (form) {
      $$('input[disabled]', form).forEach(function (i) { i.disabled = false; });
      form.classList.remove('is-busy');
    });
  });

  var page = doc.querySelector('[data-mdshop-cart]');
  if (page && !design && 'MutationObserver' in window && location.protocol !== 'file:') {
    var server = String(page.getAttribute('data-count') || '0');
    var badges = $$('[data-cart-count]').filter(function (el) { return !page.contains(el); });
    var synced = false;
    var check = function () {
      if (!badges.length) return;
      var now = String(badges[0].textContent || '').trim() || '0';
      if (!synced) { if (now === server || (now === '99+' && +server > 99)) synced = true; return; }
      if (now !== server) location.reload();
    };
    var mo = new MutationObserver(function () { setTimeout(check, 60); });
    badges.forEach(function (b) { mo.observe(b, { childList: true, characterData: true, subtree: true }); });
    check();
  }

  boot(doc);
  if (design) {
    doc.addEventListener('shopify:section:load', function (e) {
      try { boot(e.target); } catch (err) { console.error('md-shop: section set-up after an edit', err); }
    });
  }
  window.MDSHOP = { boot: boot };
})();
